import { Trans } from '@lingui/macro';
import classnames from 'classnames';
import React, { FC } from 'react';

import routes from 'utils/routeTranslator';

import './CityList.scss';

type TCity = {
  id: string;
  slug: string;
  name: string;
};

type Props = {
  cities: TCity[];
  categorySlug: string;
  categoryName: string;
  multiColumn?: boolean;
  showAllCitiesLink?: boolean;
  isL2?: boolean;
  citySlug?: string;
  isNeighbourhoods?: boolean;
};

const CityList: FC<Props> = (props) => {
  const { cities, categorySlug, multiColumn, isL2, isNeighbourhoods, citySlug, showAllCitiesLink } = props;

  const CityListCN = classnames('cityList', {
    'cityList_multiColumn': multiColumn,
  });

  const getUrl = (city: string) => {
    if (isL2) {
      return routes.get('front::categories.type', {
        slug: categorySlug,
        city,
      });
    }
    if (isNeighbourhoods) {
      return routes.get('front::category_city', {
        slug: categorySlug,
        city: citySlug,
        neighbourhood: city,
      });
    }
    return routes.get('front::category', {
      slug: categorySlug,
      city,
    });
  };

  return (
    <ul className={CityListCN}>
      {cities.map((city) => (
        <li className="cityList__city" key={city.slug}>
          <a className="cityList__link" href={getUrl(city.slug)}>
            {props.categoryName} {city.name}
          </a>
        </li>
      ))}
      {showAllCitiesLink && (
        <li className="cityList__city cityList__city_all">
          <a
            className="cityList__link"
            href={
              isL2
                ? routes.get('front::categories.cities', { slug: categorySlug })
                : routes.get('front::category.cities', { slug: categorySlug })
            }
          >
            <Trans>Wszystkie miasta</Trans>
          </a>
        </li>
      )}
    </ul>
  );
};

export default CityList;
